import angular from 'angular';
import { ISolicitacaoAlteracaoVT } from '../models/solicitacaoalteracaovt.model';
import { MeurhSolicitacoesalteracoesvtsService } from '../solicitacoesalteracoesvts.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';

export class MeurhSolicitacoesalteracoesvtsNewController implements angular.IController {
    static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$q',
        '$transitions',
        '$rootScope',
        'NewToaster',
        'MeurhSolicitacoesalteracoesvtsService',
        'ModalConfirmService',
        'TiposDocumentosRequeridosService',
    ];

    public entity = {} as ISolicitacaoAlteracaoVT;
    public action: string = 'insert';
    public tipo: string;
    public form: angular.IFormController;
    public busy: boolean = false;
    public allowRefresh: boolean = false;
    public formchanged: boolean = false;
    public entityAnexo: IAnexo = {
        casodeuso: 'ALTERACOESVTS'
    };
    public formAnexo: object = {};
    public editanexo: boolean = true;
    public busyTipoDocumentos: boolean = true;
    public tiposdocumentosrequeridos: any = [];
    public validate: number = 0; // conta quantos erros há em documentos anexos

    constructor(
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public $q: angular.IQService,
        public $transitions: any,
        public $rootScope: angular.IRootScopeService & { liberadoTela: (arg: string) => boolean },
        public NewToaster: { pop: Function },
        public entityService: MeurhSolicitacoesalteracoesvtsService,
        public ModalConfirmService: ModalConfirmService,
        public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
    ) {
        this.tipo = $stateParams['tipo'];

        this.$scope.$watch('mrh_slctcsltrcsvts_frm_nw_cntrllr.entity', (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.formchanged = true;
            }
        }, true);

        this.$scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
            this.busyTipoDocumentos = false;
            this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
                tipodocumentorequerido.validateResult = false;
                tipodocumentorequerido.fileSelecionado = false;
                return tipodocumentorequerido;
            });
        });

        this.onSubmitSuccess();
        this.onSubmitError();
        this.documentosAnexos();
        this.exitScreenDescartarModal();
        document.onkeydown = this.refreshDescartarModal;
        this.allowRefresh = true;
    }

    submit(): void {
        let podeSalvar = this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
            return (
                tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
                tipodocumentorequerido.fileSelecionado
            );
        });

        if (!podeSalvar) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Há documento(s) obrigatório(s) não informado(s)'
            });
            return;
        }

        if (this.form.$valid && !this.entity.$$__submitting) {
            if (!this.entity.solicitacoesalteracoesvtstarifas.length) {
                this.avisoVtVazioModal().then(() => {
                    this.allowRefresh = false;
                    this.save();
                }).catch(() => {/**/});
                return;
            }
            this.allowRefresh = false;
            this.save();
        } else {
            this.NewToaster.pop({
                type: 'error',
                title: 'Alguns campos do formulário apresentam erros'
            });
        }
    }

    onSubmitSuccess(): void {
        this.$scope.$on('meurh_solicitacoesalteracoesvts_submitted', (event: angular.IAngularEvent, args: any): void => {
            this.entityService.constructors.solicitacao = args.entity.solicitacao;
            this.entityAnexo['solicitacao'] = args.entity.solicitacao;

            this.$rootScope.$broadcast('meurh_todas_solicitacoes_submitted', {});
            if (this.tiposdocumentosrequeridos.length <= 0) {
                this.finalizaEnvio();
            } else {
                this.$scope.$on('meurh_todas_solicitacoes_documentos_complete', () => {
                    this.$scope.$apply(); // para atualizar os valores dos validateResult vindos do componente anexo
                    if (this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => tipodocumentorequerido.validateResult)) {
                        this.finalizaEnvio();
                    }
                });
            }
        });
    }

    finalizaEnvio(): void {
        this.NewToaster.pop({
            type: 'success',
            title: 'A Solicitação de Alteração de VT foi enviada com sucesso!'
        });

        this.$state.go('meurh_solicitacoesalteracoesvts_show', this.entityService.constructors);
    }

    onSubmitError(): void {
        this.$scope.$on('meurh_solicitacoesalteracoesvts_submit_error', (event: angular.IAngularEvent, args: any): void => {
            if (args.response.status === 409) {
                if (confirm(args.response.data.message)) {
                    this.entity[''] = args.response.data.entity[''];
                    this.save();
                }
            } else {
                if (typeof (args.response.data.message) !== 'undefined' && args.response.data.message) {
                    if (args.response.data.message === 'Validation Failed') {
                        let message = args.response.data.errors.errors[0];
                        this.NewToaster.pop({
                            type: 'error',
                            title: 'Erro de Validação',
                            body: message,
                            bodyOutputType: 'trustedHtml'
                        });
                    } else {
                        this.NewToaster.pop({
                            type: 'error',
                            title: args.response.data.message
                        });
                    }
                } else {
                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Ocorreu um erro ao enviar a Solicitação'
                    });
                }
            }
        });
    }

    save() {
        this.entityService.save(this.entity, {
            empresa: this.entity.trabalhador.empresaobj.empresa,
            estabelecimento: this.entity.trabalhador.estabelecimentoobj.estabelecimento
        });
    }

    documentosAnexos(): void {
        if (this.$rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE')) {
            this.$scope.$watch('mrh_slctcsltrcsvts_frm_nw_cntrllr.entity.trabalhador', (newValue: any, oldValue: any) => {
                if (newValue && newValue !== oldValue) {
                    const params = {
                        empresa: newValue.empresaobj.empresa,
                        estabelecimento: newValue.estabelecimentoobj.estabelecimento
                    };
                    this.entityAnexo['estabelecimento'] = params.estabelecimento;
                    this.carregaTiposDocumentosRequeridos(params);
                }
            }, true);
        } else {
            this.carregaTiposDocumentosRequeridos();
        }
    }

    carregaTiposDocumentosRequeridos(params?: {
        empresa: string,
        estabelecimento: string
    }): void {
        this.busyTipoDocumentos = true;
        this.resetTiposDocumentosRequeridosService();
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: TipoSolicitacaoEnum.ALTERACAO_VT,
            ...params
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

    resetTiposDocumentosRequeridosService(): void {
        this.tiposdocumentosrequeridos = [];
        this.TiposDocumentosRequeridosService.entities = [];
        this.TiposDocumentosRequeridosService.loadParams = {
            to_load: 3,
            busy: false,
            finished: false
        };
        this.TiposDocumentosRequeridosService.after = {};
    }

    avisoVtVazioModal() {
        const text = {
            title: 'Confirmar envio de alteração de VT',
            subtitle: 'Esta solicitação de alteração de VT não possui tarifas adicionadas.',
            confirmText: 'Deseja enviar mesmo assim?',
            closeButton: 'Cancelar',
            confirmButton: 'Enviar',
        };
        return this.ModalConfirmService.open(this.entity, 'Alteração de VT', false, text)
            .result;
    }

    buttonDescartarModal() {
        if (this.formchanged) {
            let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', false);
            confirm.result.then((): void => {
                this.allowRefresh = false;
                this.$state.go('meurh_solicitacoesalteracoesvts', angular.extend(this.entityService.constructors));
            })
            .catch((error: any): void => {/* */ });
        } else {
            this.$state.go('meurh_solicitacoesalteracoesvts', angular.extend(this.entityService.constructors));
        }
    }

    refreshDescartarModal = (e: any) => {
        e = e || window.event;
        if (this.formchanged && this.allowRefresh) {
            if (e.keyCode === 116) {
                e.preventDefault();
                let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', true);
                confirm.result.then((): void => {
                    this.allowRefresh = false;
                    window.location.reload();
                })
                .catch((error: any): void => {/* */ });
            }
        }
    }

    exitScreenDescartarModal() {
        this.$transitions.onBefore({}, (trans: any) => {
            let d = this.$q.defer();
            if (trans._targetState._identifier !== 'meurh_solicitacoesalteracoesvts_new' && this.allowRefresh && this.formchanged) {
                let confirm = this.ModalConfirmService.OpenDescartar(this.entity, ' criação', true);
                confirm.result.then((): void => {
                    this.allowRefresh = false;
                    let modalConfirmed = true;
                    if (modalConfirmed) {
                        d.resolve();
                    } else {
                        d.reject();
                    }
                })
                .catch(function () { /**/ });
            } else {
                d.resolve();
            }
            return d.promise;
        });
    }
}
